/**
 * @fileoverview O formulário de um link novo: nome, validade, senha opcional e
 * o que o link mostra além do básico (desligado por padrão, a opção mais
 * segura). O servidor confere tudo de novo.
 */

import React from "react";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";

import { i18n } from "../../translate/i18n";
import ExpirationPicker from "./ExpirationPicker";
import PasswordInput from "./PasswordInput";
import useStyles from "./styles";

const t = (key) => i18n.t(`boardShare.form.${key}`);

export const EMPTY_FORM = {
  name: "",
  expiration: { kind: "permanent", preset: "7d", custom: "" },
  usePassword: false,
  password: "",
  showContactInfo: false,
  showCardDetails: false,
};

const CheckOption = ({ checked, onChange, title, help, disabled }) => {
  const classes = useStyles();
  return (
    <label className={classes.check}>
      <Checkbox
        color="primary"
        size="small"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        inputProps={{ "aria-label": title }}
      />
      <span className={classes.checkText}>
        <span className={classes.checkTitle}>{title}</span>
        {help && <span className={classes.hint}>{help}</span>}
      </span>
    </label>
  );
};

const ShareForm = ({ value, onChange, errors = {}, disabled = false }) => {
  const classes = useStyles();
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <>
      <div className={classes.section}>
        <TextField
          className={classes.field}
          label={t("name")}
          placeholder={t("namePlaceholder")}
          value={value.name}
          onChange={(e) => set({ name: e.target.value })}
          variant="outlined"
          size="small"
          fullWidth
          autoFocus
          disabled={disabled}
          error={Boolean(errors.name)}
          helperText={errors.name || t("nameHelp")}
          inputProps={{ maxLength: 80 }}
        />
      </div>

      <ExpirationPicker value={value.expiration} onChange={(expiration) => set({ expiration })} disabled={disabled} />

      <div className={classes.section}>
        <p className={classes.label}>{t("protection")}</p>
        <CheckOption
          checked={value.usePassword}
          onChange={(usePassword) => set({ usePassword })}
          title={t("password")}
          help={t("passwordHint")}
          disabled={disabled}
        />
        {value.usePassword && (
          <PasswordInput value={value.password} onChange={(password) => set({ password })} error={errors.password} disabled={disabled} />
        )}
      </div>

      <div className={classes.section}>
        <p className={classes.label}>{t("visibility")}</p>
        <p className={classes.hint}>{t("visibilityBase")}</p>
        <CheckOption
          checked={value.showContactInfo}
          onChange={(showContactInfo) => set({ showContactInfo })}
          title={t("contactInfo")}
          help={t("contactInfoHelp")}
          disabled={disabled}
        />
        <CheckOption
          checked={value.showCardDetails}
          onChange={(showCardDetails) => set({ showCardDetails })}
          title={t("cardDetails")}
          help={t("cardDetailsHelp")}
          disabled={disabled}
        />
        <p className={classes.hint}>{t("never")}</p>
      </div>
    </>
  );
};

export default ShareForm;
